import * as React from 'react';
import { Modal, Button, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';

interface IProps {
    show: boolean,
    medicareParticipating: string,
    onSave: (medicareParticipating: number) => void,
    onCancel: () => void
}

interface IState {
    medicareParticipating: string,
    valid: boolean,
    dirty: boolean
}

class MedicareParticipating extends React.Component<IProps, IState> {
    readonly state: IState = {
        medicareParticipating: this.props.medicareParticipating,
        valid: true,
        dirty: false
    }

    handleValueChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            medicareParticipating: e.currentTarget.value
        });
    }

    handleSave = () => {
        let valid = this.state.medicareParticipating != '' && Utility.isNumber(this.state.medicareParticipating);

        this.setState({
            valid,
            dirty: true
        }, () => {
            if (valid) {
                this.props.onSave(parseFloat(this.state.medicareParticipating));
            }
        });
    }

    render = () => {
        return (
            <Modal backdrop='static' show={this.props.show} onHide={() => this.props.onCancel()} dialogClassName='medicare-participating'>
                <Modal.Header closeButton>
                    <Modal.Title>Medicare Participating Amount</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <FormGroup style={{ marginBottom: 0 }} validationState={this.state.valid ? null : 'error'}>
                        <div style={{ marginBottom: 10 }}>Please enter the Medicare participating amount...</div>
                        <FormControl
                            type='text'
                            value={this.state.medicareParticipating}
                            onChange={this.handleValueChange}
                        />
                        {!this.state.valid && (
                            <HelpBlock>Please specify a valid dollar amount</HelpBlock>
                        )}
                    </FormGroup>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleSave}>Save</Button>
                    <Button onClick={() => this.props.onCancel()}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default MedicareParticipating;